import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const showTradeConfirmationAtom = atomWithStorage<boolean>(
  "showTradeConfirmation",
  false,
);

export const useShowTradeConfirmation = () => {
  const [showTradeConfirmation, setShowTradeConfirmation] = useAtom(
    showTradeConfirmationAtom,
  );

  return {
    showTradeConfirmation,
    setShowTradeConfirmation,
  };
};
